<tgrid-restoration-metric-map-widget
  title="Impact Level"
  metric="impact_level"
  mapId="restoration-metric-impact-map-widget"
  countyLabelPrefix="Most impacted counties:"
  subtitle="Impact Level is the maximum number of customers impacted during an outage event."
  exportFileName="restoration_metric_impact_level">
</tgrid-restoration-metric-map-widget>
